import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function ValidationField(values) {
  let errors = [];

  values.forEach((item, index) => {
    let errorObj = {};

    const levelError = ValidateField(
      item.level?.value,
      ValidateName?.LEVEL,
      ValidateName?.LEVEL,
      [ValidateName?.REQUIRED],
    );
    if (levelError) errorObj.level = levelError;

    if (item.approvers && item.approvers.length > 0) {
      let approverErrors = [];
      item.approvers.forEach((approver, idx) => {
        const approverType = approver.approverType?.value || "SpecificUser";
        let approverError = {};

        if (approverType === "TransactionRole") {
          const roleError = ValidateField(
            approver.role?.value || approver.roleId,
            "User role",
            "User role",
            [ValidateName?.REQUIRED],
          );
          if (roleError) {
            approverError.role = roleError;
          }
        } else if (approverType === "SpecificUser") {
          const userError = ValidateField(
            approver.user?.value,
            ValidateName?.USERNAME,
            ValidateName?.USERNAME,
            [ValidateName?.REQUIRED],
          );
          if (userError) approverError.user = userError;
        } else if (approverType === "SelectedUsersInRole") {
          const roleError = ValidateField(
            approver.role?.value || approver.roleId,
            "User role",
            "User role",
            [ValidateName?.REQUIRED],
          );
          if (roleError) approverError.role = roleError;

          if (!approver.userIds?.length) {
            approverError.userIds = `${ValidateName?.USERNAME} is required`;
          }
        } else if (approverType === "RolePool") {
          const roleError = ValidateField(
            approver.role?.value || approver.roleId,
            "User role",
            "User role",
            [ValidateName?.REQUIRED],
          );
          if (roleError) approverError.role = roleError;
        }

        if (Object.keys(approverError).length > 0) {
          approverErrors[idx] = approverError;
        }
      });

      if (approverErrors.length > 0) {
        errorObj.approvers = approverErrors;
      }
    } else {
      errorObj.approvers = [{ user: `${ValidateName?.USERNAME} is required` }];
    }

    if (Object.keys(errorObj).length > 0) {
      errors[index] = errorObj;
    } else {
      errors[index] = {}; 
    }
  });

  return errors;
}
